import React from 'react';
import tw from 'twin.macro';
import { navigationContactUs } from '@utils/navigation';
import { FormattedMessage } from 'gatsby-plugin-intl';

import Text from '@components/text';
import ButtonDefault from '@components/button';
import Link from '@components/link';

const Button = tw(ButtonDefault)`mt-35 mb-60 lg:mt-30 lg:mb-0`;

const CTA = () => (
  <Link to="/for-business" hash="form">
    <Button>
      <Text color="white" fontSizes={16} fontWeight={600} lineHeight={1.4} letterSpacing={20}>
        <FormattedMessage id={navigationContactUs.translation} />
      </Text>
    </Button>
  </Link>
);

export default CTA;
